// Replacement for https://lodash.com/docs/4.17.15#sum
export const sum = (arrayOfNumbers: number[]) => {
    return arrayOfNumbers.reduce((acc, num) => {
        acc += num;
        return acc;
    }, 0);
};
